/* eslint-disable react/jsx-no-comment-textnodes */
import * as React from "react";
import Layout from "../Layout/MasterLayout/MasterLayout";
import CardNews from "../components/CardNews/CardNews";
import CardEditais from "../components/CardEditais/CardEditais";
import Button from "../components/Button/Button";
import CardConteudo from "../components/CardConteudoButton/CardConteudo";

import { MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdbreact";

import imgAcontece from "../assets/images/acontece/acontece.png";
import SEO from "../components/SEO/SEO";

import '../components/css/images.css'

export default function AconteceNaEscola() {
	return (
		<Layout>
			<SEO title="Acontece na escola" lang="pt-br"/>
			<MDBContainer>
				<MDBRow>
					<MDBCol col={12} md={7} className="order-1 order-sm-0 my-auto">
						<h1 className="pageTitle fgprimary-gradient">acontece na escola</h1>
						<p className="text-justify">
							// estamos sempre construindo experiências transformadoras para
							nossos estudantes. Conecte-se conosco para acompanhar tudo o que
							acontece na Escola de Aplicação Feevale.
						</p>
					</MDBCol>
					<MDBCol
						col={12}
						md={5}
						className="py-5 text-justify order-0 order-sm-1 imagemTopo"
					>
						<img src={imgAcontece} className="img-fluid" />
					</MDBCol>
				</MDBRow>
				<CardConteudo
								key={1}
								title={"Festival Radical"}
							
								description={'Convidamos você e seus amigos para participar do <b>Festival Radical</b>, que será realizado no dia <b>26 de abril (sábado)</b>, das <b>9h às 11h30</b>, no <b>pátio e no campo da Escola de Aplicação Feevale.</b><br/>O evento foi organizado com o objetivo de promover a integração e proporcionar vivências significativas entre estudantes, familiares, amigos e toda a comunidade escolar.<br/><br/><b>Atividades Programadas</b><ul><li>Atividades Recreativas</li><li>Banda Fermatinha</li><li>Brechó do Terceirão</li><li>Escalada</li><li>Jogos de Tabuleiro</li><li>Lanche do Terceirão</li><li>Mini Vôlei</li><li>Multiesportes</li><li>Parkour</li><li>Ping Pong</li><li>Punhobol</li><li>Slackline</li><li>Tirolesa</li><li>Trilha</li></ul><br/><b>Importante:</b><br/>Não se esqueça de trazer seu chimarrão e sua cadeira para aproveitar o evento! Além disso, para participar da trilha na mata, é essencial usar repelente. Em caso de chuva, o evento será cancelado.<br/>Venha viver um sábado diferente com a gente! Sua presença fará toda a diferença para tornar este momento ainda mais especial.<br/>Esperamos por você!'}
								borderColor={"institucional"}
								
							/>
			</MDBContainer>
			<br/>
			<CardNews />
			<CardEditais />
			<MDBContainer className="pt-5">
				<MDBRow>
					<MDBCol col={12} md={6} className="pt-4 pt-md-0">
						<h3 className="fgprimary-gradient">conecte-se com a escola</h3>
						<MDBContainer fluid className="px-0 mx-0 text-center text-md-left">
							<MDBRow className="d-inline-flex p-0 m-0">
								<MDBCol col={3} className="text-center py-3 px-0">
									<a
										href="https://twitter.com/escolafeevale"
										target="_blank"
										rel="noreferrer"
									>
										<span className="fa-stack fa-2x">
											<MDBIcon
												icon="circle fa-stack-2x"
												size="2x"
												className="fgprimary-gradient"
											/>
											<MDBIcon fab icon="twitter text-white fa-stack-1x" />
										</span>
									</a>
								</MDBCol>
								<MDBCol col={3} className="text-center py-3 px-0">
									<a
										href="https://www.instagram.com/escolafeevale"
										target="_blank"
										rel="noreferrer"
									>
										<span className="fa-stack fa-2x">
											<MDBIcon
												icon="circle fa-stack-2x"
												size="2x"
												className="fgprimary-gradient"
											/>
											<MDBIcon fab icon="instagram text-white fa-stack-1x" />
										</span>
									</a>
								</MDBCol>
								<MDBCol col={3} className="text-center py-3 px-0">
									<a
										href="https://www.facebook.com/escolafeevale"
										target="_blank"
										rel="noreferrer"
									>
										<span className="fa-stack fa-2x">
											<MDBIcon
												icon="circle fa-stack-2x"
												size="2x"
												className="fgprimary-gradient"
											/>
											<MDBIcon fab icon="facebook-f text-white fa-stack-1x" />
										</span>
									</a>
								</MDBCol>
								<MDBCol col={3} className="text-center py-3 px-0">
									<a
										href="https://open.spotify.com/user/8mdbgc7knnnwq7e7s56tid1pc?si=T2fGI3xTRBK5Y9OYE4mjXg"
										target="_blank"
										rel="noreferrer"
									>
										<span className="fa-stack fa-2x">
											<MDBIcon
												icon="circle fa-stack-2x"
												size="2x"
												className="fgprimary-gradient"
											/>
											<MDBIcon fab icon="spotify text-white fa-stack-1x" />
										</span>
									</a>
								</MDBCol>
							</MDBRow>
						</MDBContainer>
					</MDBCol>
				</MDBRow>
			</MDBContainer>
		</Layout>
	);
}
